import { type RoleConstants } from "../state/userSlice";

const AI_TUTOR_ALLOWED_ROLES: RoleConstants[] = ["Admin", "Educator", "Tutor", "Parent"];

const CANDIDATE_SEARCH_ALLOWED_ROLES: RoleConstants[] = ["Admin", "Human Resources"];

export function hasAITutorAccess(roles: RoleConstants[]): boolean {
  return roles.some((role) => AI_TUTOR_ALLOWED_ROLES.includes(role));
}

export function hasCandidateSearchAccess(roles: RoleConstants[]): boolean {
  return roles.some((role) => CANDIDATE_SEARCH_ALLOWED_ROLES.includes(role));
}

export function hasResumeBuilderAccess(roles: RoleConstants[]): boolean {
  return roles.some((role) => role === "Candidate");
}
